import BaseComponent from 'foundation/base-component';
import { tns } from 'tiny-slider/src/tiny-slider';
import eventBus from 'general/js/event-bus';

const MOBILE_BREAKPOINT = 1023;

const SUBLAYOUT_FULLWIDTH_ENABLE = 'SUBLAYOUT_FULLWIDTH_ENABLE';
const SUBLAYOUT_FULLWIDTH_DISABLE = 'SUBLAYOUT_FULLWIDTH_DISABLE';
const LIVE_EVENT_HOME_PAGE_CLASS = 'sublayout--live-event-two-column-home-page';
const LIVE_EVENT_HOME_PAGE_NO_BROADCASTER_CLASS = 'is-homepage-hero-fullwidth';
const BROADCASTERS_SELECTOR = '.broadcasters';
const RIGHT_COLUMN_SELECTOR = '.sublayout__col-2';

class SublayoutComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.slider = null;
        this.handleResize = this.handleResize.bind(this);

        this.init();
    }

    init() {
        eventBus.addListener(SUBLAYOUT_FULLWIDTH_ENABLE, this.enableFullwidth);
        eventBus.addListener(SUBLAYOUT_FULLWIDTH_DISABLE, this.disableFullwidth);

        this.toggleLiveHomepageLayout();
        this.toggleMobileSlider();
        window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.toggleMobileSlider();
    }

    toggleMobileSlider() {
        if (!this.element.classList.contains('sublayout--slide')) {
            return;
        }

        const grid = this.element.querySelector('.sublayout__grid');
        const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

        if (isMobile) {
            if (!this.slider && grid) {
                this.slider = tns({
                    container: grid,
                    items: 1,
                    slideBy: 1,
                    gutter: 0,
                    nav: true,
                    navPosition: 'bottom',
                    controls: false,
                    mouseDrag: true,
                    swipeAngle: false,
                    loop: false,
                });
            }
        } else {
            if (this.slider) {
                this.slider.destroy();
                this.slider = null;
            }
        }
    }

    toggleLiveHomepageLayout() {
        if (!this.element.classList.contains(LIVE_EVENT_HOME_PAGE_CLASS)) {
            return;
        }

        const rightColumn = this.element.querySelector(RIGHT_COLUMN_SELECTOR);
        const hasBroadcasters = rightColumn && rightColumn.querySelector(BROADCASTERS_SELECTOR);

        this.element.classList.toggle(LIVE_EVENT_HOME_PAGE_NO_BROADCASTER_CLASS, !hasBroadcasters);
    }

    onDestroy() {
        eventBus.removeListener(SUBLAYOUT_FULLWIDTH_ENABLE, this.enableFullwidth);
        eventBus.removeListener(SUBLAYOUT_FULLWIDTH_DISABLE, this.disableFullwidth);

        window.removeEventListener('resize', this.handleResize);
        if (this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    enableFullwidth = () => {
        this.element.classList.add('is-fullwidth');
    }

    disableFullwidth = () => {
        this.element.classList.remove('is-fullwidth');
    }
}

export default SublayoutComponent;
